// src/components/coachText.js
//
// The coach writes **bold** and real line breaks; the thread and the history
// sheet render both the same way. Never innerHTML.

import React from "react";

export function renderCoachText(text) {
  const s = String(text || "");
  const re = /\*\*([^*]+)\*\*/g;
  const out = [];
  let last = 0;
  let m;
  while ((m = re.exec(s)) !== null) {
    if (m.index > last) out.push(s.slice(last, m.index));
    out.push(<strong key={`b-${m.index}`}>{m[1]}</strong>);
    last = m.index + m[0].length;
  }
  if (last < s.length) out.push(s.slice(last));
  return out.length ? out : s;
}

export function plainCoachText(text) {
  return String(text || "").replace(/\*\*/g, "").replace(/\s+/g, " ").trim();
}
